import { Base } from 'layouts'
import { UserList } from 'components'

import * as S from './styled'

export function User() {
  return (
    <Base>
      <S.GridContainer container>
        <UserList />
      </S.GridContainer>
    </Base>
  )
}
